import { Options, Vue } from "vue-class-component";
import Toggle from "@vueform/toggle";

import { PaymentType } from "@/domain/payment-type.model";
import { ErrorType } from "@/interfaces/error";

@Options({
  name: "payment-type-edit",
  props: {
    id: String,
  },
  components: {
    Toggle,
  },
})
export default class PaymentTypeEdit extends Vue {
  public id: string;
  public errorMessage = "";
  public errors: ErrorType = {};
  public hasError = false;
  public row: PaymentType = {
    description: "",
    enabled: false,
  };

  public mounted(): void {
    this.$store
      .dispatch("paymentType/get", this.id)
      .then((res: PaymentType) => {
        if (res && res.id) {
          this.row = res;
        } else {
          this.errorMessage = "Registro não encontrado.";
        }
      })
      .catch(() => {
        this.errorMessage = "Registro não encontrado.";
      });
  }

  public goBack() {
    this.$router.push("/payment-type");
  }

  public validation() {
    this.errors = {};
    this.hasError = false;

    if (!this.row.description) {
      this.errors.description = "Este campo deve ser preenchido.";
      this.hasError = true;
    }

    return !this.hasError;
  }

  public save() {
    if (this.validation()) {
      this.$store
        .dispatch("paymentType/update", {
          id: parseInt(this.id),
          description: this.row.description,
          enabled: this.row.enabled,
        })
        .then(() => {
          this.$router.push("/payment-type");
        })
        .catch(() => {
          this.errorMessage = "Ocorreu um erro ao gravar o registro.";
        });
    }
  }
}
